<input id="slider-component" type="text" data-slider-id="slider-ele" data-slider-handle="custom"/>
